var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "home" } },
    [
      _c("Loading", { attrs: { loadingHide: _vm.loadingHide } }),
      _vm._v(" "),
      _c("Header"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "carouselBox" },
        [
          _vm.carouselList.length
            ? _c(
                "el-carousel",
                { attrs: { interval: 5000 } },
                _vm._l(_vm.carouselList, function (item, index) {
                  return _c(
                    "el-carousel-item",
                    {
                      key: index,
                      class: item.content ? "curp" : "",
                      nativeOn: {
                        click: function ($event) {
                          return _vm.handleCarousel(item)
                        },
                      },
                    },
                    [
                      _c("img", { attrs: { src: item.pic, alt: "" } }),
                      _vm._v(" "),
                      item.content
                        ? _c("span", { staticClass: "characteristic" }, [
                            _vm._v("点击查看详情"),
                          ])
                        : _vm._e(),
                    ]
                  )
                }),
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("section", { attrs: { id: "team" } }, [
        _vm.choicenessCardList.length
          ? _c("div", { staticClass: "container" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "row" },
                _vm._l(_vm.choicenessCardList, function (item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "col-sm-6 col-md-3" },
                    [
                      _c("div", { staticClass: "team_member" }, [
                        _c(
                          "div",
                          {
                            staticClass: "entry",
                            on: {
                              click: function ($event) {
                                return _vm.goContentPage(item.id)
                              },
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "img-responsive",
                              attrs: { src: item.cover },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "lawyer" }, [
                          _c("h3", [_vm._v(_vm._s(item.name))]),
                          _vm._v(" "),
                          _c("div", { staticClass: "lawyer-details" }, [
                            _c(
                              "div",
                              { staticClass: "user-panel border-top" },
                              [
                                _c("img", {
                                  staticClass: "user-headimg",
                                  attrs: {
                                    src: item.authorAvatar
                                      ? item.authorAvatar
                                      : "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.goUserHome(item.authorId)
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.goUserHome(item.authorId)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        item.authorName ? item.authorName : ""
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "user-panel" }, [
                              _c("ul", { staticClass: "user-eyes" }, [
                                _c(
                                  "li",
                                  { staticClass: "likes" },
                                  [
                                    _c("svg-icon", {
                                      staticClass: "like",
                                      attrs: {
                                        "icon-class": item.zansStatus
                                          ? "zan-active"
                                          : "zan",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.giveLike(3, item, index)
                                        },
                                      },
                                    }),
                                    _vm._v(
                                      _vm._s(item.likeNum) +
                                        "\n                                            "
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("li", { staticClass: "eyes" }, [
                                  _c("i", { staticClass: "el-icon-view" }),
                                  _vm._v(_vm._s(item.visNum)),
                                ]),
                              ]),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _vm.choicenessCardList.length >= 8
                ? _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12 text-center see_more_button" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "attorney-button",
                            attrs: {
                              to: {
                                name: "works",
                                params: { sort: "topDate" },
                              },
                            },
                          },
                          [_vm._v("查看更多")]
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "container" }, [
          _vm._m(1),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row" },
            _vm._l(_vm.hotCardList, function (item, index) {
              return _c(
                "div",
                { key: index, staticClass: "col-sm-6 col-md-3" },
                [
                  _c("div", { staticClass: "team_member" }, [
                    _c(
                      "div",
                      {
                        staticClass: "entry",
                        on: {
                          click: function ($event) {
                            return _vm.goContentPage(item.id)
                          },
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "img-responsive",
                          attrs: { src: item.cover },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "lawyer" }, [
                      _c("h3", [_vm._v(_vm._s(item.name))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "lawyer-details" }, [
                        _c("div", { staticClass: "user-panel border-top" }, [
                          _c("img", {
                            staticClass: "user-headimg",
                            attrs: {
                              src: item.authorAvatar ? item.authorAvatar : "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.goUserHome(item.authorId)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.goUserHome(item.authorId)
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(item.authorName ? item.authorName : "")
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "user-panel" }, [
                          _c("ul", { staticClass: "user-eyes" }, [
                            _c(
                              "li",
                              { staticClass: "likes" },
                              [
                                _c("svg-icon", {
                                  staticClass: "like",
                                  attrs: {
                                    "icon-class": item.zansStatus
                                      ? "zan-active"
                                      : "zan",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.giveLike(1, item, index)
                                    },
                                  },
                                }),
                                _vm._v(
                                  _vm._s(item.likeNum) +
                                    "\n                                            "
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("li", { staticClass: "eyes" }, [
                              _c("i", { staticClass: "el-icon-view" }),
                              _vm._v(_vm._s(item.visNum)),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-12 text-center see_more_button" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "attorney-button",
                    attrs: {
                      to: { name: "works", params: { sort: "visNum" } },
                    },
                  },
                  [_vm._v("查看更多")]
                ),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "container" }, [
          _vm._m(2),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row" },
            _vm._l(_vm.createCardList, function (item, index) {
              return _c(
                "div",
                { key: index, staticClass: "col-sm-6 col-md-3" },
                [
                  _c("div", { staticClass: "team_member" }, [
                    _c(
                      "div",
                      {
                        staticClass: "entry",
                        on: {
                          click: function ($event) {
                            return _vm.goContentPage(item.id)
                          },
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "img-responsive",
                          attrs: { src: item.cover, alt: "" },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "lawyer" }, [
                      _c("h3", [_vm._v(_vm._s(item.name))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "lawyer-details" }, [
                        _c("div", { staticClass: "user-panel border-top" }, [
                          _c("img", {
                            staticClass: "user-headimg",
                            attrs: {
                              src: item.authorAvatar ? item.authorAvatar : "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.goUserHome(item.authorId)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.goUserHome(item.authorId)
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(item.authorName ? item.authorName : "")
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "user-panel" }, [
                          _c("ul", { staticClass: "user-eyes" }, [
                            _c(
                              "li",
                              { staticClass: "likes" },
                              [
                                _c("svg-icon", {
                                  staticClass: "like",
                                  attrs: {
                                    "icon-class": item.zansStatus
                                      ? "zan-active"
                                      : "zan",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.giveLike(2, item, index)
                                    },
                                  },
                                }),
                                _vm._v(
                                  _vm._s(item.likeNum) +
                                    "\n                                            "
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("li", { staticClass: "eyes" }, [
                              _c("i", { staticClass: "el-icon-view" }),
                              _vm._v(_vm._s(item.visNum)),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-12 text-center see_more_button" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "attorney-button",
                    attrs: {
                      to: { name: "works", params: { sort: "createDate" } },
                    },
                  },
                  [_vm._v("查看更多")]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("Foot"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title text-center" }, [
      _c("h3", { staticClass: "title-text" }, [_vm._v("精选作品")]),
      _vm._v(" "),
      _c("p", { staticClass: "lead" }, [_vm._v("Selected works")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title text-center" }, [
      _c("h3", { staticClass: "title-text" }, [_vm._v("最热作品")]),
      _vm._v(" "),
      _c("p", { staticClass: "lead" }, [_vm._v("Hot works")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title text-center" }, [
      _c("h3", { staticClass: "title-text" }, [_vm._v("最新作品")]),
      _vm._v(" "),
      _c("p", { staticClass: "lead" }, [_vm._v("The latest work")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/home/home.vue?vue&type=template&id=39f87be5&
// module id = null
// module chunks = 